import React, { useState } from "react";
import { SectionLabel } from "utility/Constant";

export default function ProductPriceDetails({ Details, secMetalDetail, stoneDetail }) {
  const [expanded, setExpanded] = useState(true);

  const stoneTotal = (stoneDetail || []).reduce(
    (sum, s) => sum + (parseFloat(s.totalValue) || 0),
    0
  );

  const taxTotal = (
    Math.trunc((Details.saleTaxList?.[0]?.amount || 0) +
    (Details.saleTaxList?.[1]?.amount || 0) +
    parseFloat(Details.secGoldTax || 0) +
    (Details.diamondTax || 0) +
    (Details.platinumTax || 0))
  );

  const subTotal =
    Math.trunc((Details.basePrice || 0) +
    (Details.diamondTotal || 0) +
    (Details.platinumTotal || 0) +
    (Details.secGoldTotal || 0));

  const hallmarkTotal =
    Details.hallmarkCharge > 0
      ? Math.trunc(Details.hallmarkCharge + Details.hallmarkCharge * ((Details.hmTaxPercentage || 0) / 100))
      : 0;

  const grandTotal = (Details.total && Details.pieceRate > 0) ?Math.trunc(Details.total) : (Details.total && Details.pieceRate <= 0) ? Math.trunc(Details.total) : 0;

  const todayMetalRate = Details.pieceRate > 0 ? 0 :  Details.productTypeName.toLowerCase() === 'gold' ?  Math.trunc(Details.goldNet * Details.todayRate) : Math.trunc(Details.silverNet * Details.todayRate)

  const Row = ({ label, value, highlight, accent }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "10px 0",
      borderBottom: "1px solid #f3edf9",
    }}>
      <span style={{
        fontSize: 13, fontWeight: highlight ? 700 : 500,
        color: highlight ? "#1a0d2e" : "#6b5c82",
        textTransform: "capitalize",
      }}>
        {label}
      </span>
      <span style={{
        fontSize: highlight ? 15 : 13,
        fontWeight: highlight ? 700 : 600,
        color: accent ? "#7c3aad" : highlight ? "#4f3267" : "#4a3a60",
        fontFamily: highlight ? "Cormorant Garamond, Georgia, serif" : "inherit",
      }}>
        {value}
      </span>
    </div>
  );

  return (
    <div>
      <SectionLabel>Price Details</SectionLabel>

      {/* Breakdown toggle */}
      <button
        onClick={() => setExpanded((v) => !v)}
        style={{
          width: "100%",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "10px 14px",
          background: expanded ? "#f5f0fa" : "#faf7fd",
          border: "1px solid #e8d9f8",
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 12.5, fontWeight: 700, letterSpacing: ".06em",
          color: "#4f3267",
          textTransform: "uppercase",
          transition: "background .14s",
          marginBottom: expanded ? 0 : 0,
        }}
      >
        <span>Price Breakdown</span>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5"
          style={{ transform: expanded ? "rotate(180deg)" : "none", transition: "transform .2s" }}
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {expanded && (
        <div style={{
          border: "1px solid #e8d9f8",
          borderTop: "none",
          borderRadius: "0 0 10px 10px",
          padding: "4px 16px 4px",
          background: "#fdfbff",
        }}>
          {todayMetalRate > 0 && 
          <Row
            label={Details.metalType || "Metal"}
            value={`₹${todayMetalRate.toLocaleString("en-IN")}`}
          />
          }
          {Details.wastageCost > 0 &&
          <Row
            label={'Wastage'}
            value={`₹${Math.trunc(Details.wastageCost).toLocaleString("en-IN")}`}
          />
          }
          {Details.makingCost > 0 && 
          <Row
            label={'Making Charge'}
            value={`₹${Math.trunc(Details.makingCost).toLocaleString("en-IN")}`}
          />
          }
          {/* {secMetalDetail && secMetalDetail.length > 0 && (
            <Row
              label={secMetalDetail[0].productTypeName || "Secondary Metal"}
              value={`₹${((Details.diamondTotal || 0) + (Details.platinumTotal || 0) + (Details.secGoldTotal || 0)).toFixed(2)}`}
            />
          )} */}
          {stoneTotal > 0 && (
            <Row
              label="Stone Value"
              value={`₹${Math.trunc(stoneTotal).toLocaleString("en-IN")}`}
            />
          )}
          {Details.otherCharge > 0 &&
          <Row label='Other Charge' value={`₹${Math.trunc(Details.otherCharge).toLocaleString("en-IN")}`}/>
          }
          <Row
            label="Sub-Total"
            value={`₹${subTotal.toLocaleString("en-IN")}`}
          />
          <Row
            label="Tax (3%)"
            value={`₹${taxTotal.toLocaleString("en-IN")}`}
          />
          {hallmarkTotal > 0 && (
            <Row
              label={Details.hmTaxPercentage > 0 ? "Hallmark (with tax)" : "Hallmark Charge"}
              value={`₹${hallmarkTotal.toLocaleString("en-IN")}`}
            />
          )}
          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 0 8px",
          }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#1a0d2e", textTransform: "capitalize" }}>
              Grand Total
            </span>
            <span style={{
              fontSize: 16, fontWeight: 700,
              color: "#7c3aad",
              // fontFamily: "Cormorant Garamond, Georgia, serif",
            }}>
              ₹{grandTotal.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      )}

       {/* Grand total card */}
      <div style={{
        background: "linear-gradient(135deg, #4f3267 0%, #7c3aad 100%)",
        borderRadius: 14,
        padding: "18px 20px",
        marginBottom: 14,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <div>
          <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: ".12em", textTransform: "uppercase", color: "rgba(255,255,255,.65)", margin: "0 0 4px" }}>
            Grand Total
          </p>
          <p style={{ fontSize: 11, color: "rgba(255,255,255,.5)", margin: 0, fontStyle: "italic" }}>
            *Inclusive of all taxes
          </p>
        </div>
        <div style={{
          // fontFamily: "Cormorant Garamond, Georgia, serif",
          fontSize: "clamp(26px,3vw,34px)",
          fontWeight: 700,
          color: "#fff",
          letterSpacing: ".01em",
        }}>
          ₹{grandTotal.toLocaleString("en-IN")}
        </div>
      </div>
    </div>
  );
}